import { CommonModule, JsonPipe } from '@angular/common';
import { Component, computed, input, OnInit, output, signal } from '@angular/core';

import { ImportWizardService } from '../../import-wizard.service';
import { ImportWizardTabularPreviewComponent } from './step1-preview/import-wizard-tabular-preview.component';
import { StepInterface, StepperComponent } from 'src/app/shared/stepper/stepper.component';
import { ImportWizardTabularMappingAdjustComponent } from './step2-mapping_adjusts/import-wizard-tabular-mapping_adjust.component';
import { ImportWizardTabularConfirmationValidationComponent } from './step3-confirmation_validation/import-wizard-tabular-confirmation_validation.component';
import { ImportWizardStep, ImportWizardStorage } from '../../import-wizard.storage';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { ImportWizardPendingStorage } from '../../components/pending-list/import-wizard-pending-list.storage';
import { ImportWizardPendingService } from '../../components/pending-list/import-wizard-pending-list.service';
import { DatasetType } from '@/app/dtos/import-wizard/import-wizard.dto';


@Component({
    selector: 'app-import-wizard-tabular',
    templateUrl: './import-wizard-tabular.component.html',
    styleUrls: ['./import-wizard-tabular.component.scss'],
    imports: [
        CommonModule,
        ImportWizardTabularPreviewComponent,
        ImportWizardTabularMappingAdjustComponent,
        ImportWizardTabularConfirmationValidationComponent,
        StepperComponent,
        AlertComponent
    ],
    standalone: true
})
export class ImportWizardTabularComponent implements OnInit{
    _filename = computed(() => this.importWizardStorage.state().filename);

    _state = computed(() => this.importWizardStorage.state());

    _currentStep = computed(() => this.importWizardStorage.step());
    _inViewStep = computed(() => this.importWizardStorage.inViewStep());
  
    steps = computed<StepInterface[]>(() => {
        const current = this._currentStep();

        return [
            {
                id: ImportWizardStep.PREVIEW,
                label: 'Preview',
                stepNumber: ImportWizardStep.PREVIEW,
                description: 'Visualize os dados a serem importados',
                isCompleted: current > ImportWizardStep.PREVIEW,
                isDisabled: false
            },
            {
                id: ImportWizardStep.MAPPING_ADJUSTS,
                label: 'Mapeamento e Ajustes',
                stepNumber: ImportWizardStep.MAPPING_ADJUSTS,
                description: 'Mapeie e ajuste os dados',
                isCompleted: current > ImportWizardStep.MAPPING_ADJUSTS,
                isDisabled: current <= ImportWizardStep.PREVIEW
            },
            {
                id: ImportWizardStep.VALIDATION_CONFIRM,
                label: 'Validação e Confirmação',
                stepNumber: ImportWizardStep.VALIDATION_CONFIRM,
                description: 'Valide e confirme a importação',
                isCompleted: current > ImportWizardStep.VALIDATION_CONFIRM,
                isDisabled: current <= ImportWizardStep.MAPPING_ADJUSTS
            }
        ];
    });

    hasMappingStepChanges = computed(() => this.importWizardStorage.mappingHasChanges());
    isAlertMappingHasChangesOpen = signal<boolean>(false);
    _redirectStep = signal<ImportWizardStep | null>(null);

    constructor(
        public importWizardService: ImportWizardService,
        public importWizardStorage: ImportWizardStorage,
        private importWizardPendingStorage: ImportWizardPendingStorage,
        private importWizardPendingService: ImportWizardPendingService,
    ) {}

    ngOnInit(): void {
        if(this.importWizardStorage.state().isShared) return;
        // this.refetchPendingImports();
    }

    onStepChange(event: StepInterface) { 
        if(this._state().inViewStep === ImportWizardStep.MAPPING_ADJUSTS && this.hasMappingStepChanges()) {
            this._redirectStep.set(event.id);
            this.openAlertMappingHasChanges();
        } else { 
            this.importWizardStorage.redirectInViewStep(event.id);
        }
    }

    // private refetchPendingImports() {
    //     this.importWizardPendingService.useGetAllPendingImports(DatasetType.TABULAR).subscribe({
    //         next: (data) => {
    //             this.importWizardPendingStorage.setPendingImports(data);
    //         },
    //         error: (error) => {
    //             console.error(error);
    //         }
    //     });
    // }

    private openAlertMappingHasChanges() { 
        this.isAlertMappingHasChangesOpen.set(true);
    }

    handleAlertMappingHasChangesConfirm() { 
        this.isAlertMappingHasChangesOpen.set(false);
        this.importWizardStorage.redirectInViewStep(this._redirectStep()!);
    }

    handleAlertMappingHasChangesCancel() { 
        this._redirectStep.set(null);
        this.isAlertMappingHasChangesOpen.set(false);
    }

    ImportWizardStep = ImportWizardStep;
}